module.exports = __webpack_public_path__ + "img/arrow-up.5022aa7e.svg";